module.exports = __webpack_public_path__ + "components/country-flag/static/mk-9aa33f5855d873bf510891411ff24ddd.svg";